import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { SolanaMobileWalletAdapter } from '@solana-mobile/wallet-adapter-mobile';

// Import wallet adapter CSS
import '@solana/wallet-adapter-react-ui/styles.css';

const HELIUS_RPC = 'https://mainnet.helius-rpc.com/?api-key=f8567a96-fef3-4752-88d4-6338fb67e1b0';

export const WalletContextProvider = ({ children }) => {
  const endpoint = useMemo(() => HELIUS_RPC, []);

  // MWA for mobile browsers, Phantom/Solflare for desktop,
  // Wallet Standard wallets are auto-detected by WalletProvider
  const wallets = useMemo(
    () => [
      new SolanaMobileWalletAdapter({
        appIdentity: {
          name: 'Canary',
          uri: 'https://canarywallet.app',
          icon: '/canary_logo.png',
        },
        cluster: 'mainnet-beta',
      }),
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};
